function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var svgToDataUri = require('mini-svg-data-uri');

var plugin = require('tailwindcss/plugin');

var defaultTheme = require('tailwindcss/defaultTheme');

var _defaultTheme$fontSiz = _slicedToArray(defaultTheme.fontSize.base, 2),
    baseFontSize = _defaultTheme$fontSiz[0],
    baseLineHeight = _defaultTheme$fontSiz[1].lineHeight;

var colors = defaultTheme.colors,
    spacing = defaultTheme.spacing,
    borderWidth = defaultTheme.borderWidth,
    borderRadius = defaultTheme.borderRadius,
    outline = defaultTheme.outline;
var forms = plugin(function (_ref) {
  var _addBase;

  var addBase = _ref.addBase,
      theme = _ref.theme;
  addBase((_addBase = {}, _defineProperty(_addBase, "\n      [type='text'],\n      [type='email'],\n      [type='url'],\n      [type='password'],\n      [type='number'],\n      [type='date'],\n      [type='datetime-local'],\n      [type='month'],\n      [type='search'],\n      [type='tel'],\n      [type='time'],\n      [type='week'],\n      [multiple],\n      textarea,\n      select\n    ", {
    appearance: 'none',
    'background-color': '#fff',
    'border-color': theme('colors.gray.500', colors.gray[500]),
    'border-width': borderWidth['DEFAULT'],
    'border-radius': borderRadius.none,
    'padding-top': spacing[2],
    'padding-right': spacing[3],
    'padding-bottom': spacing[2],
    'padding-left': spacing[3],
    'font-size': baseFontSize,
    'line-height': baseLineHeight,
    '&:focus': {
      outline: outline.none[0],
      'outline-offset': outline.none[1],
      '--tw-ring-inset': 'var(--tw-empty,/*!*/ /*!*/)',
      '--tw-ring-offset-width': '0px',
      '--tw-ring-offset-color': '#fff',
      '--tw-ring-color': theme('colors.blue.600', colors.blue[600]),
      '--tw-ring-offset-shadow': "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      '--tw-ring-shadow': "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      'box-shadow': "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
      'border-color': theme('colors.blue.600', colors.blue[600])
    }
  }), _defineProperty(_addBase, 'input::placeholder, textarea::placeholder', {
    color: theme('colors.gray.500', colors.gray[500]),
    opacity: '1'
  }), _defineProperty(_addBase, '::-webkit-datetime-edit-fields-wrapper', {
    padding: '0'
  }), _defineProperty(_addBase, '::-webkit-date-and-time-value', {
    'min-height': '1.5em'
  }), _defineProperty(_addBase, "select", {
    'background-image': "url(\"".concat(svgToDataUri("<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\"><path stroke=\"".concat(theme('colors.gray.500', colors.gray[500]), "\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M6 8l4 4 4-4\"/></svg>")), "\")"),
    'background-position': "right ".concat(spacing[2], " center"),
    'background-repeat': "no-repeat",
    'background-size': "1.5em 1.5em",
    'padding-right': spacing[10],
    'color-adjust': "exact"
  }), _defineProperty(_addBase, '[multiple]', {
    'background-image': 'initial',
    'background-position': 'initial',
    'background-repeat': 'unset',
    'background-size': 'initial',
    'padding-right': spacing[3],
    'color-adjust': 'unset'
  }), _defineProperty(_addBase, "\n      [type='checkbox'],\n      [type='radio']\n    ", {
    appearance: 'none',
    padding: '0',
    'color-adjust': 'exact',
    display: 'inline-block',
    'vertical-align': 'middle',
    'background-origin': 'border-box',
    'user-select': 'none',
    'flex-shrink': '0',
    height: spacing[4],
    width: spacing[4],
    color: theme('colors.blue.600', colors.blue[600]),
    'background-color': '#fff',
    'border-color': theme('colors.gray.500', colors.gray[500]),
    'border-width': borderWidth['DEFAULT']
  }), _defineProperty(_addBase, "[type='checkbox']", {
    'border-radius': borderRadius['none']
  }), _defineProperty(_addBase, "[type='radio']", {
    'border-radius': '100%'
  }), _defineProperty(_addBase, "\n      [type='checkbox']:focus,\n      [type='radio']:focus\n    ", {
    outline: outline.none[0],
    'outline-offset': outline.none[1],
    '--tw-ring-inset': 'var(--tw-empty,/*!*/ /*!*/)',
    '--tw-ring-offset-width': '2px',
    '--tw-ring-offset-color': '#fff',
    '--tw-ring-color': theme('colors.blue.600', colors.blue[600]),
    '--tw-ring-offset-shadow': "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    '--tw-ring-shadow': "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    'box-shadow': "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  }), _defineProperty(_addBase, "\n      [type='checkbox']:checked,\n      [type='radio']:checked\n    ", {
    'border-color': "transparent",
    'background-color': "currentColor",
    'background-size': "100% 100%",
    'background-position': "center",
    'background-repeat': "no-repeat"
  }), _defineProperty(_addBase, "[type='checkbox']:checked", {
    'background-image': "url(\"".concat(svgToDataUri("<svg viewBox=\"0 0 16 16\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z\"/></svg>"), "\")")
  }), _defineProperty(_addBase, "[type='radio']:checked", {
    'background-image': "url(\"".concat(svgToDataUri("<svg viewBox=\"0 0 16 16\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"8\" cy=\"8\" r=\"3\"/></svg>"), "\")")
  }), _defineProperty(_addBase, "\n      [type='checkbox']:checked:hover,\n      [type='checkbox']:checked:focus,\n      [type='radio']:checked:hover,\n      [type='radio']:checked:focus\n    ", {
    'border-color': 'transparent',
    'background-color': 'currentColor'
  }), _defineProperty(_addBase, "[type='checkbox']:indeterminate", {
    'background-image': "url(\"".concat(svgToDataUri("<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path stroke=\"white\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 8h8\"/></svg>"), "\")"),
    'border-color': "transparent",
    'background-color': "currentColor",
    'background-size': "100% 100%",
    'background-position': "center",
    'background-repeat': "no-repeat"
  }), _defineProperty(_addBase, "\n      [type='checkbox']:indeterminate:hover,\n      [type='checkbox']:indeterminate:focus\n    ", {
    'border-color': 'transparent',
    'background-color': 'currentColor'
  }), _defineProperty(_addBase, "[type='file']", {
    background: 'unset',
    'border-color': 'inherit',
    'border-width': '0',
    'border-radius': '0',
    padding: '0',
    'font-size': 'unset',
    'line-height': 'inherit'
  }), _defineProperty(_addBase, "[type='file']:focus", _defineProperty({
    outline: "1px solid ButtonText"
  }, "outline", "1px auto -webkit-focus-ring-color")), _addBase));
});
module.exports = forms;